import MentoringWomanIcon from './MentoringWomanIcon.vue';

export default MentoringWomanIcon;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/components/avatar/components/stub/components/woman/index.ts